import React from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import { Button } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';

//pdfMake.vfs = pdfFonts.pdfMake.vfs;
//window.JSZip = jsZip;




const  UsedBomDatatable = (props) => {

   const [t] = useTranslation();      
   const tableName = '';

   const clickHandler = (row) => {
            //row.target.id      
            if(typeof(row.target.id) !== 'undefined' && row.target.id != null){            
                props.modalCallback(true,row.target.id);  
            }
   
    };

   const columns = [       
            { name: "Id", data: "id", selector: "id", omit: true},
            { name: t('article.label.article'), data: "article.name", sortable: true, selector: "article.name"},           
            { name: t('article.label.articleNumber'), data: "article.nbr", sortable: true, selector: "article.nbr"},    
            { name: t('document.label.qty'), data: "qty", sortable: true, selector: "qty"},    
         
        ];        


        
    const columnsData = [       
        { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('article.label.article'), data: "article.name",  orderable: true, searchable: true, search: {value: '',regex: false}},          
        { name: t('article.label.articleNumber'), data: "article.nbr",  orderable: true, searchable: true, search: {value: '',regex: false}},           
        { name: t('document.label.qty'), data: "qty",  orderable: true, searchable: true, search: {value: '',regex: false}}
    ];        
    const url = RestService.getBaseURL()+"workOrder/getBomOnOperationList?id="+props.operationId;  
    const urlExcel = RestService.getBaseURL()+"workOrder/getExcelBomOnOperationList?id="+props.operationId;          
 
    const handleCallback  = (id) => {
            props.parentCallback(id);                   
    };
  
     
   
   
        return (
          
            <DataTableX
                url={url}  
                urlExcel={urlExcel}  
                tableName={tableName}
                columns={columns}   
                columnsData={columnsData}
                parentCallback={handleCallback}
                modalShow={props.modalShow}
                checkTime={props.checkTime}
            />
         
        );
   

 
};


export default UsedBomDatatable;

